import { render, staticRenderFns } from "./ModelTable.vue?vue&type=template&id=25a1139e&scoped=true"
import script from "./ModelTable.vue?vue&type=script&lang=js"
export * from "./ModelTable.vue?vue&type=script&lang=js"
import style0 from "./ModelTable.vue?vue&type=style&index=0&id=25a1139e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1139e",
  null
  
)

export default component.exports